export const LGAS = [
  { name: 'Bakori',      zone: 'South',   tier: 'C' },
  { name: 'Batagarawa', zone: 'Central', tier: 'B' },
  { name: 'Batsari',    zone: 'Central', tier: 'D' },
  { name: 'Baure',      zone: 'North',   tier: 'B' },
  { name: 'Bindawa',    zone: 'Central', tier: 'C' },
  { name: 'Charanchi',  zone: 'North',   tier: 'C' },
  { name: 'Dan Musa',   zone: 'North',   tier: 'D' },
  { name: 'Dandume',    zone: 'South',   tier: 'D' },
  { name: 'Danja',      zone: 'South',   tier: 'C' },
  { name: 'Daura',      zone: 'North',   tier: 'B' },
  { name: 'Dutsi',      zone: 'North',   tier: 'C' },
  { name: 'Dutsin-Ma',  zone: 'North',   tier: 'B' },
  { name: 'Faskari',    zone: 'South',   tier: 'D' },
  { name: 'Funtua',     zone: 'South',   tier: 'A' },
  { name: 'Ingawa',     zone: 'Central', tier: 'C' },
  { name: 'Jibia',      zone: 'North',   tier: 'B' },
  { name: 'Kafur',      zone: 'Central', tier: 'B' },
  { name: 'Kaita',      zone: 'North',   tier: 'B' },
  { name: 'Kankara',    zone: 'Central', tier: 'B' },
  { name: 'Kankia',     zone: 'North',   tier: 'C' },
  { name: 'Katsina',    zone: 'Central', tier: 'A' },
  { name: 'Kurfi',      zone: 'Central', tier: 'C' },
  { name: 'Kusada',     zone: 'Central', tier: 'C' },
  { name: "Mai'adua",   zone: 'North',   tier: 'B' },
  { name: 'Malumfashi', zone: 'South',   tier: 'B' },
  { name: 'Mani',       zone: 'Central', tier: 'C' },
  { name: 'Mashi',      zone: 'North',   tier: 'B' },
  { name: 'Matazu',     zone: 'South',   tier: 'C' },
  { name: 'Musawa',     zone: 'South',   tier: 'D' },
  { name: 'Rimi',       zone: 'South',   tier: 'C' },
  { name: 'Sabuwa',     zone: 'South',   tier: 'D' },
  { name: 'Safana',     zone: 'Central', tier: 'D' },
  { name: 'Sandamu',    zone: 'North',   tier: 'C' },
  { name: 'Zango',      zone: 'Central', tier: 'C' },
]

export const AGENT_CLASSES = [
  { value: '1', label: 'Class 1 — Full Spectrum' },
  { value: '2', label: 'Class 2 — Mid Specialist / Yearly' },
  { value: '3', label: 'Class 3 — Low Specialist / Yearly' },
]

export const INFRACTION_TYPES = [
  'Off-Platform Collection',
  'Unauthorized Receipt Issuance',
  'Pre-print Receipt',
  'Receipt Recycling',
  'Failure to Fund Wallet',
  'Failure to Vend / Under-Vending',
  'Revenue Shortfall',
  'No Project Jacket / ID',
  'Terminal Misuse',
  'Inactive Agent Days',
  'Ghost Transactions',
  'Failure to Follow Project Guidelines',
]

export const SCORE_BANDS = [
  { min: 85, max: 100, band: 'PLATINUM',  colour: '#1A6B3A', bg: '#D5F5E3', commission: 'Full + Project Prize',  action: 'Project Prize awarded. Star Agent badge.' },
  { min: 70, max: 84,  band: 'COMPLIANT', colour: '#1A6B3A', bg: '#D5F5E3', commission: 'Full',                  action: 'No action. Monitored weekly.' },
  { min: 50, max: 69,  band: 'WATCHLIST', colour: '#7D6608', bg: '#FEF9E7', commission: 'Full',                  action: '30-day improvement plan. Supervisor notified.' },
  { min: 40, max: 49,  band: 'HIGH RISK', colour: '#922B21', bg: '#FDEDEC', commission: 'Reviewed',              action: 'Level 1 written warning by EVC PMO. Field audit.' },
  { min: 0,  max: 39,  band: 'CRITICAL',  colour: '#7B241C', bg: '#FDEDEC', commission: 'Withheld',              action: 'Level 2–3 action. Guarantee fund drawn. Wallet balance withheld.' },
]

export const SECURITY_LEVELS = [
  { value: 'Green',  label: 'Green — Safe',             factor: 1.00 },
  { value: 'Orange', label: 'Orange — Partially Safe',  factor: 0.75 },
  { value: 'Red',    label: 'Red — Dangerous',          factor: 0.50 },
]

export const TIERS = ['A', 'B', 'C', 'D']
export const ZONES = ['North', 'Central', 'South']

export const COLOURS = {
  navy:   '#0F4761',
  amber:  '#B7770D',
  green:  '#1A6B3A',
  red:    '#922B21',
  white:  '#FFFFFF',
  grey:   '#F0F4F8',
  dgrey:  '#595959',
}

export function getBand(score) {
  return SCORE_BANDS.find(b => score >= b.min && score <= b.max) || SCORE_BANDS[4]
}

export function calcScore({ receiptCompliance, walletFunding, transactionVolume, revenueVsTarget, incidents }) {
  // Revenue vs Target: 75 on 0-100 scale = exactly hitting target
  const revRaw = revenueVsTarget >= 75 ? 100 : Math.round((revenueVsTarget / 75) * 100)
  const incRaw = Math.max(0, 100 - (incidents * 15))
  return (
    (receiptCompliance  * 0.25) +
    (walletFunding      * 0.20) +
    (transactionVolume  * 0.20) +
    (revRaw             * 0.20) +
    (incRaw             * 0.15)
  )
}
